import { Component } from '@angular/core';

@Component({
   selector: 'lib-user-avatar',
   templateUrl: './user-avatar.component.html',
   inputs: [ 'user', 'size' ],
})
export class UserAvatarComponent {
   user: {
      email: string;
      avatar?: any;

      initials?: string;
   };

   size = 40;
}
